import React, { FC, useMemo } from 'react'
import {
  CircularProgress as ChakraCircularProgress,
  CircularProgressProps,
  useColorModeValue,
} from '@chakra-ui/react'
import { useColor } from '../../theme'

type TVariant = 'convert' | 'upload' | 'uploadMultiple'

interface ICircularProgressProps extends CircularProgressProps {
  variant?: TVariant
}

export const CircularProgress: FC<ICircularProgressProps> = ({
  variant,
  ...restProps
}) => {
  const convertColor = useColor({ palette: 'primary', nuance: 5 })
  const uploadColor = useColor({ palette: 'primary', nuance: 2 })
  const uploadMultipleColor = useColor({ palette: 'text', nuance: 2 })
  // Since the colors correspond to different nuance, useColorModeValue is used.
  const trackColor = useColorModeValue(
    'rw1.secondary.light.1',
    'rw1.secondary.dark.2',
  )

  const colorByVariant = useMemo(
    (): Record<TVariant, string> => ({
      convert: convertColor,
      upload: uploadColor,
      uploadMultiple: uploadMultipleColor,
    }),
    [convertColor, uploadColor, uploadMultipleColor],
  )

  return (
    <ChakraCircularProgress
      color={variant && colorByVariant[variant]}
      isIndeterminate={variant === 'uploadMultiple'}
      size={4}
      thickness={16}
      trackColor={trackColor}
      {...restProps}
    />
  )
}
